var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.block ? _c('div', {
    staticClass: "two_col"
  }, [_c('div', [_c('div', {
    staticClass: "utxo_label"
  }, [_vm._v("Block")]), _c('div', [_c('a', {
    staticClass: "block",
    attrs: {
      "href": _vm.cURL
    }
  }, [_vm._v(_vm._s(_vm.block))])])]), _vm.nonce > 0 ? _c('div', [_c('div', {
    staticClass: "utxo_label"
  }, [_vm._v("Nonce")]), _c('div', [_vm._v(_vm._s(_vm.nonce))])]) : _vm._e()]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }